import styled, { css, createGlobalStyle } from 'styled-components'
import { color } from 'ui/themes/utils'

export const HostStyles = createGlobalStyle`
  :host, :root {
    --minicart-launcher-height: 60px;
    --minicart-launcher-open-width: 325px;
    --minicart-launcher-bottom: 16px;
    --minicart-launcher-right: 16px;
    --minicart-launcher-accent-color: var(--color-accent-background, ${color('branding')});
    --minicart-launcher-background-color: var(--color-accent-foreground, ${color('white')});
    --minicart-launcher-border-radius: var(--border-radius-sm, 8px);
    --minicart-launcher-padding: 8px;
    --minicart-launcher-font-size: 13px;
    --minicart-launcher-icon-size: 26px;
    --minicart-launcher-font: var(--font-body, --minicart-font, Source Sans Pro, sans-serif);
    --minicart-launcher-shadow: 0px 4px 12px 0px ${color('black')};
  }
`

export const Launcher = styled.div`
  display: flex;
  position: fixed;

  right: var(--minicart-launcher-right);
  bottom: var(--minicart-launcher-bottom);

  height: var(--minicart-launcher-height);
  width: var(--minicart-launcher-height);

  font-family: var(--minicart-launcher-font);

  overflow: hidden;

  border-radius: var(--minicart-launcher-border-radius);

  cursor: pointer;

  transition: width 0.5s ease-in-out 0.1s;
  transition-delay: 0.5s;

  box-shadow: var(--minicart-launcher-shadow);

  &:hover {
    ${({ cartOpen }) => !cartOpen && css`
      width: var(--minicart-launcher-open-width);
    `}
  }

`

export const MiniCartContainer = styled.div`
  position: fixed;
  right: 16px;
  bottom: 84px;
`

export const Icon = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  height: var(--minicart-launcher-height);
  min-width: var(--minicart-launcher-height);

  color: var(--minicart-launcher-background-color);
  background: var(--minicart-launcher-accent-color);

  > svg {
    font-size: var(--minicart-launcher-icon-size);
    height: var(--minicart-launcher-icon-size);
    width: var(--minicart-launcher-icon-size);
  }
`

export const Summary = styled.div`
  padding: var(--minicart-launcher-padding);

  font-size: var(--minicart-launcher-font-size);

  width: calc(var(--minicart-launcher-open-width) - var(--minicart-launcher-height));
  /* Akwardly split line to please eslint */
  min-width: calc(var(--minicart-launcher-open-width) - var(--minicart-launcher-height)
    - (var(--minicart-launcher-padding) * 2));
`

export const Dates = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > svg {
    font-size: var(--minicart-launcher-font-size);
    height: var(--minicart-launcher-font-size);
    width: var(--minicart-launcher-font-size);
  }
`

export const Details = styled.div`
 > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
 }
`

Launcher.MiniCartContainer = MiniCartContainer
Launcher.Icon = Icon
Launcher.Summary = Summary
Launcher.Dates = Dates
Launcher.Details = Details

export default Launcher
